export default "__VITE_ASSET__C2_F9692__"